<script setup>
  import { ref, onBeforeMount, computed} from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useJobsStore } from "@/stores/jobs";
import { useFilesStore } from "@/stores/files";

  const uiStore = useUiStore();
  const jobsStore = useJobsStore();
  const filesStore = useFilesStore();
  const company_id = useCompanyStore().companyId;
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  const emit = defineEmits(['refresh']);
  let id = ref(null);
  let name = ref(null);
  let type = ref(null);
  let isSubmitted = ref(false);

  const resetStoreData = () =>{
    uiStore.resetModalStore();

    document.querySelector(".modal-backdrop").remove();
    document.querySelector(".dx-device-desktop").classList.remove('modal-open');

  };

  const onSubmit = () => {
    isSubmitted.value = true;

    let action;
    if(type.value == 'folder'){
      action = () => jobsStore.deleteFolder({id: id.value, companyId: company_id});
    } else if(type.value == 'file'){
      action = () => filesStore.deleteFile({id: id.value, companyId: company_id});
    } else if(type.value == 'job'){
      action = () => jobsStore.deleteJob({id: id.value, companyId: company_id});
    }

    action()
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });

  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalAction.value == 'delete_folder_and_job'){
      id.value = getModalInfo.value.id;
      name.value = getModalInfo.value.name;
      type.value = getModalInfo.value.type;
    }
  });
</script>
<template>
  <DModal v-if="getModalAction === 'delete_folder_and_job'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete File </template>

    <template #body>

      <div class="delete-text mb-3">
        <span v-if="type == 'job'">Are you sure you want to <b>"Delete"</b> the job <b>{{ name }}</b> ?</span>
        <span v-if="type == 'folder'">Are you sure you want to <b>"Delete"</b> the folder <b>{{ name }}</b> ?</span>
        <span v-if="type == 'file'">Are you sure you want to <b>"Delete"</b> the file <b>{{ name }}</b> ?</span>
      </div>
      <p v-if="type == 'folder'" class="delete-text">Please ensure you have migrated all associated jobs first.</p>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-danger add-button mr-30" >
            Delete <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  
